import { APPBAR_HEIGHT } from '@/components/header/AppBar'

const FIXED_SUMMARY_HEIGHT = 96 + 24
const SUMMARY_HEIGHT = 360

export const checkSummaryStickyPosition = () => {
  const appBarHeight = Number(APPBAR_HEIGHT.replace('px', ''))
  return appBarHeight + SUMMARY_HEIGHT - FIXED_SUMMARY_HEIGHT < window.scrollY
}
